export const RulesCorp = [
  {
    text: "1) Министерство здравоохранения Свердловской области. Отдел организации медецинской деятельности г.Екатеринбург ул.Вайнера 34б, тел:",
    tel: "83432701818",
  },
  {
    text: "2) Отдел экспертизы в сфере защиты прав потребителей ФГУЗ «Центр гигиены и эпидемиологии» в Свердловской области, тел:",
    tel: "83433741455",
  },
  {
    text: "3) Росздравнадзор г.Екатеринбург ул.Попова 30, тел:",
    tel: "834337163662",
  },
  {
    text: "4) Территорориальный отдел управления федеральной службы по надзору в сфере защиты прав потребителей г.Первоуральск ул.Вайнера 4, тел:",
    tel: "83439245215",
  },
];
